export default "__VITE_ASSET__BLMpusmt__"